import React from 'react';
import { SlotStatus } from '../../data/types';
interface AvailabilityDotProps {
  status: SlotStatus;
  showLabel?: boolean;
  dimmed?: boolean;
}
const statusConfig: Record<SlotStatus, {
  color: string;
  label: string;
}> = {
  available: {
    color: 'bg-available',
    label: 'Available'
  },
  booked: {
    color: 'bg-booked',
    label: 'Booked'
  },
  blocked: {
    color: 'bg-blocked',
    label: 'Blocked'
  },
  internal: {
    color: 'bg-internal',
    label: 'Internal Use'
  },
  removed: {
    color: 'bg-removed',
    label: 'Removed'
  }
};
export function AvailabilityDot({
  status,
  showLabel = true,
  dimmed = false
}: AvailabilityDotProps) {
  const config = statusConfig[status];
  return <div className={`flex items-center gap-1.5 ${dimmed ? 'opacity-30' : ''}`} data-id="element-561">
      <span className={`w-2 h-2 rounded-full ${config.color}`} aria-hidden="true" data-id="element-562" />
      {showLabel && <span className="text-xs text-text-secondary" data-id="element-563">{config.label}</span>}
    </div>;
}